<template>
  <div class="mb-12">
    <el-dialog
      :visible.sync="centerDialogVisible"
      width="35%"
      center
      class="ne-oppop"
      v-if="this.selectedPlan[0].subscription.name !== ''"
    >
      <div class="bg-primary p-4 flex justify-between items-center">
        <h2 class="text-white fsize14 my-0">Resource Utilization</h2>
        <feather-icon
          icon="XIcon"
          svgClasses="w-4 h-4"
          class="cursor-pointer text-white"
          @click="
            () => {
              centerDialogVisible = false;
            }
          "
        />
      </div>
      <div class="p-4 items-center">
        <div class="flex justify-center w-full">
          <img
            src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/hello.png"
            class="new-height"
          />
        </div>

        <p class="fsize14 text-dark text-center font-medium my-4">
          Resource Management is available on BRAINED's Business Subscription.
          Please upgrade to Business Subscription to access this feature
        </p>

        <div class="flex w-full mt-4 gap-2">
          <vs-button
            color="primary"
            class="bg-primary w-full"
            @click="
              () => {
                centerDialogVisible = false;
                this.$router.push({ name: 'plans-vue' });
              }
            "
            >Upgrade</vs-button
          >

          <vs-button
            color="secondary"
            class="bg-secondary w-full"
            @click="centerDialogVisible = false"
            >Cancel</vs-button
          >
        </div>
      </div>
    </el-dialog>

    <h2 class="text-565656 fsize18 font-semibold border-b pb-4">Performance</h2>

    <div class="grid gap-4 grid-cols-3 mt-6">
      <div
        class="cursor-pointer effecthover rounded-lg"
        v-for="(item, index) in cards"
        :key="'item -' + index"
        @click="
          selectedProject.intellectualProperty === false
            ? handleClick(item)
            : ''
        "
        :class="
          selectedProject.intellectualProperty === true
            ? 'bg-f5f5f5 cursor-not-allowed opacity'
            : 'cursor-pointer'
        "
      >
        <div class="flex items-center bg-lightf4f5f6 border-round p-3">
          <div class="flex gap-4 items-center w-10/12">
            <img
              :src="item.image"
              class="object-contain w-16 h-16 bg-ec rounded-lg"
              alt="banh"
            />

            <div class="w-full">
              <h3 class="col-4f fsize14 font-medium mb-0">
                {{ item.title }}
              </h3>
            </div>
          </div>
          <div class="w-2/12 flex justify-end cursor-pointer">
            <div>
              <!-- <img
                src="@/assets/images/aright.png"
                class="w-35px rounded-full"
              /> -->
              <div
                class="flex justify-center bg-light-secondary rounded-full items-center w-10 h-10"
              >
                <feather-icon
                  icon="ChevronRightIcon"
                  svgClasses="w-5 h-5"
                  class="text-secondary font-semibold flex"
                  @click="
                    () => {
                      this.$router.push({ path: '/admin-panel/marcom' });
                    }
                  "
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  data() {
    return {
      centerDialogVisible: false,
      plans: "",
      cards: [
        {
          id: "01",
          title: "Error log",
          image:
            "https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/assets/13.png",
          route: "performance-errorlog",
        },
        {
          id: "02",
          title: "Application log",
          image: require("@/assets/images/icons/domain stup.svg"),
          route: "application-Log",
        },
        {
          id: "03",
          title: "Resource Utlilization",
          image:
            "https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/Ecom/ecom2.svg",
          route: "performance-utlilization",
        },
      ],
    };
  },
  computed: {
    ...mapState("logs", ["errorlog"]),
    ...mapState("admin", ["selectedPlan"]),
    ...mapState("modules", ["modulesList"]),
    ...mapState("user", ["selectedProject"]),
  },
  methods: {
    handleClick(item) {
      let access = false;
      this.modulesList.forEach((x) => {
        if (x.name === item.title) {
          access = x.access_control;
        }
      });
      if (!access) {
        this.$router.push({ name: "coming" });
      } else {
        if (item.title === "Resource Utlilization") {
          if (this.selectedPlan[0].subscription.name !== "Business") {
            this.centerDialogVisible = true;
          } else {
            this.centerDialogVisible = false;
            this.$router.push({ name: item.route });
          }
        } else {
          this.$router.push({ name: item.route });
        }
      }
    },
    async GetErrorLog() {
      try {
        const payload = {};
        let data = await this.$store.dispatch("logs/ErrorLOG", payload);
      } catch (err) {
        console.log();
      }
    },
    async getPlans() {
      const { data } = await this.$store.dispatch("billing/getAllPlans");
      this.plans = data;
    },
  },
  async mounted() {
    await this.getPlans();
    this.GetErrorLog();
    console.log(this.errorlog, "errorlogerrorlog");
  },
};
</script>
